import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import html2pdf from "html2pdf.js";
import PdfTemplate from '../../component/Print1.js';
import ReactDOMServer from 'react-dom/server';
import { set } from 'date-fns';
import Loader from '../../component/Loader.js';




export default function CourseVerification() {


  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/admin/");
  }

  const tableRef = useRef(null);

  const [semester_id, setSemester] = useState("");
  const [candidateType, setCandidateType] = useState(1);
  const collegename = localStorage.getItem('username');

  const [remark, setRemarks] = useState("");

  const [loading, setloading] = useState(false);
  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);


  const [filteredStudents, setFilteredStudents] = useState([]);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [issaved, setissaved] = useState(1);
  const [status, setStatus] = useState(false);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [isFirstReject, setFirstReject] = useState(false);
  const [getApaarIDS, setApaarIDS] = useState([]);




  // Holds the fetched students based on discipline
  const currentDate = new Date();

  const { http } = Api();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
//custom discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/Admin/getActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears()


  }, []);

  const fetchStatus = async (selectedSemester) => {
    try {
      const response = await http.get('getActiveEvents', { params: { event_id: 4 } });

      const { status, semester_id } = response.data[0];

      setStatus(semester_id === selectedSemester && status === 'active');

    } catch (error) {

      console.log(error);
    }
  };

  const handleSemesterChange = (selectedOption) => {
    setSemester(selectedOption.value);
    fetchStatus(selectedOption.value);
  };


  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
  };

  const handleAdmissionYearChange = (selectedOption) => {
    setAdmissionYear(selectedOption.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/Admin/getCollegeDisciplines`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchTableData = async () => {
      setIsSelectAllChecked(false);

      try {
        const response = await http.get(`/College/viewCourseVerificationList`, {
          params: {
            admissionyear: admissionYear,
            semester_id: semester_id,
            discipline_id: disciplineId,
            inside_outside: candidateType,
            college_course_type: disciplinetype

          },
        });

        const studentsData = response.data.studentlist;
        setFilteredStudents(Object.entries(studentsData));
      } catch (error) {
        console.error("Error fetching student data:", error);
        setFilteredStudents([]);
      }
    };

    if (admissionYear && semester_id && disciplineId) {
      setissaved(1);
      setSelectedStudents([]);
      fetchTableData();
    }

  }, [admissionYear, semester_id, disciplineId, candidateType, issaved]);

  // const handleGeneratePrintPDF = async () => {

  //   let date = new Date();
  //   const response = await http.get(`/getDateandTime`).then(response => {

  //     date = response.data;
  //   }).catch(error => {
  //     if (error.response.data.status_code === 'ERR9') {
  //       toast.error("Invalid token");
  //       setTimeout(() => {
  //         navigate('/');
  //       }, 5000);
  //     }
  //   })

  //   if (Array.isArray(filteredStudents) && filteredStudents.length > 0) {
  //     try {
  //       setlodaing(true);
  //       const element = (
  //         <PdfTemplate data={filteredStudents} />
  //       );
  //       const pdfElement = document.createElement('div');
  //       pdfElement.innerHTML = ReactDOMServer.renderToStaticMarkup(element);

  //       const config = {
  //         margin: [40, 20, 60, 20],
  //         filename: `${collegename}_course_list.pdf`,
  //         image: { type: 'jpeg', quality: 0.98 },
  //         html2canvas: {
  //           scale: 2,
  //           useCORS: true,
  //           letterRendering: true,
  //           scrollY: -window.scrollY,
  //         },
  //         jsPDF: {
  //           unit: 'pt',
  //           format: 'a4',
  //           orientation: 'portrait',
  //           compressPDF: true,
  //         },
  //         pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  //       };

  //       await html2pdf().from(pdfElement).set(config).toPdf().get('pdf').then(async (pdf) => {
  //         const totalPages = pdf.internal.getNumberOfPages();

  //         // Create a canvas for the watermark
  //         const canvas = document.createElement('canvas');
  //         const ctx = canvas.getContext('2d');
  //         const pageWidth = pdf.internal.pageSize.getWidth();
  //         const pageHeight = pdf.internal.pageSize.getHeight();
  //         canvas.width = pageWidth;
  //         canvas.height = pageHeight;

  //         // Draw the watermark on the canvas
  //         ctx.fillStyle = 'rgba(200, 200, 200, 0.5)'; // Semi-transparent light gray
  //         ctx.font = '60px Helvetica';
  //         ctx.textAlign = 'center';
  //         ctx.textBaseline = 'middle';
  //         ctx.save();
  //         ctx.translate(pageWidth / 2, pageHeight / 2);
  //         ctx.rotate(Math.PI / 4); // Rotate 45 degrees
  //         ctx.fillText("DRAFT", 0, 0);
  //         ctx.restore();

  //         // Convert the canvas to an image
  //         const imgData = canvas.toDataURL('image/png');

  //         for (let i = 1; i <= totalPages; i++) {
  //           pdf.setPage(i);

  //           // Add the watermark image to the background
  //           pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight);

  //           // Add footer and page number
  //           pdf.setFontSize(10); // Normal size for footer and page number
  //           pdf.setTextColor(88, 31, 55); // Dark color for footer and page number

  //           // Draw line above footer
  //           pdf.setDrawColor(88, 31, 55);
  //           pdf.setLineWidth(0.5);
  //           pdf.line(20, pageHeight - 30, pageWidth - 20, pageHeight - 30);

  //           // Footer content
  //           pdf.setFont("helvetica", "normal");
  //           pdf.text("© Mahatma Gandhi University,Priyadarsini Hills, Kottayam, Kerala, India - 686560", pageWidth / 2, pageHeight - 20, { align: "center" });
  //           pdf.text(date, pageWidth / 2, pageHeight - 5, { align: "center" });
  //           pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 40, 30, { align: "right" });
  //         }
  //       }).save();
  //       setlodaing(false);
  //     } catch (error) {
  //       setlodaing(false)
  //       toast.error("Error generating PDF");
  //       console.error("Error generating PDF:", error);
  //     }
  //   } else {
  //     toast.error("No data found");
  //   }
  // };

  const handleSelectAll = () => {
    const allSelected = !isSelectAllChecked;
    setIsSelectAllChecked(allSelected);

    if (allSelected) {
      // Select all students' apaarId
      const allStudentIds = filteredStudents
        .filter(([apaarId, studentDetails]) => studentDetails?.studentstatus !== 'Not Verified')
        .map(([apaarId]) => apaarId);
      setSelectedStudents(allStudentIds);

    } else {
      // Deselect all
      setSelectedStudents([]);
    }
  };

  const handleCheckboxChange = (apaarId) => {
    if (selectedStudents.includes(apaarId)) {
      // Deselect the student
      const student = selectedStudents.filter(id => id !== apaarId)
      setSelectedStudents(student);

      if (student.length === 0) {
        setIsSelectAllChecked(false);
      }

    } else {
      // Select the student
      setSelectedStudents([...selectedStudents, apaarId]);
    }
  };

  const handlefirstsubmit = () => {

    if (selectedStudents.length === 0) {
      toast.error("No students selected");
      return;
    }
    setFirstSubmit(!isFirstSubmit);

  }

  const handleApproveAll = () => {
    setFirstSubmit(!isFirstSubmit);
    setloading(true);

    http.post(`College/principalApproveCourseVerification`, {

      semester_id: semester_id,
      apaar_no: selectedStudents

    })
      .then(response => {
        setloading(false);

        if (response.data.status_code === "MSG13") {

          toast.success("Data Stored Successfully");
          setissaved(0);
        }
      }).catch(error => {
        setloading(false);
        setFirstSubmit(!isFirstSubmit);
        if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
          toast.error("Data not found");
        }
        else if (error.response.data.status_code === 'ERR1') {
          toast.error("Validation Failed");
        }
        else if (error.response.data.status_code === 'ERR2' || error.response.data.http_status === 500) {
          toast.error("Error while inserting");
        }
        else if (error.response.data.status_code === 'ERR38') {
          toast.error("Paper count mismatch. Select all fields");
        }
        else if (error.response.data.status_code === 'ERR36') {
          toast.error("Parameter request failed");
        }
        else if (error.response.data.status_code === 'ERR5' || error.response.data.http_status === 500) {
          toast.error("Data not found");
        }
        else {
          // console.error("Error in Submission of courses:", error);
          toast.error("Something went wrong: ");
        }

      })

  }
  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    // window.location.reload();
  }

  const handlefirstReject = (apparid) => {

    if (!remark || remark.trim().length === 0) {
      toast.error("Please enter remarks");
      return;
    }
    setApaarIDS(apparid);
    setFirstReject(!isFirstReject);


  }

  const handleReject = (apparid) => {
    setFirstReject(!isFirstReject);


    http.post(`College/principalRejectionCourseVerification`, {

      semester_id: semester_id,
      apaar_no: apparid,
      remarks: remark

    })
      .then(response => {

        if (response.data.message.status_code === "MSG15") {
          setRemarks('');
          toast.success("Course Registration Rejected by Principal");
          setissaved(2);
        }
      }).catch(error => {
        setFirstSubmit(!isFirstSubmit);

        if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
          toast.error("Data not found");
        }
        else if (error.response.data.status_code === 'ERR1') {
          toast.error("Validation Failed");
        }
        else if (error.response.data.status_code === 'ERR2' || error.response.data.http_status === 500) {
          toast.error("Error while inserting");
        }
        else if (error.response.data.status_code === 'ERR38') {
          toast.error("Paper count mismatch. Select all fields");
        }
        else if (error.response.data.status_code === 'ERR36') {
          toast.error("Parameter request failed");
        }
        else if (error.response.data.status_code === 'ERR5' || error.response.data.http_status === 500) {
          toast.error("Data not found");
        }
        else {
          // console.error("Error in Submission of courses:", error);
          toast.error("Something went wrong: ");
        }

      })

  }

  const handleRejectCancel = () => {
    setFirstReject(!isFirstReject);
    // window.location.reload();
  }

  const handleGeneratePDFNew = async () => {
    try {
      const response = await http.get('/College/viewCourseVerificationListPdf', {
        params: {
          admissionyear: admissionYear,
          discipline_id: disciplineId,
          semester_id: semester_id,
          inside_outside: candidateType,
          college_course_type: disciplinetype
        },
        responseType: 'blob'
      });

      if (response && response.data) {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${localStorage.getItem('username')}_${disciplineName}_Semester${semester_id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return Promise.resolve('PDF generated successfully ');

      }

    } catch (error) {
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }
  };

  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          /* <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */

          <Loader />

        ) : (
          <div className="my-page">

            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Student Course Selection Approval</h5>
                          <div className="buttons-container">

                            {Array.isArray(filteredStudents) && filteredStudents.length > 0 && (

                              <button
                                className="lbl2 btn btn-primary m-r-10"
                                onClick={handleGeneratePDFNew}
                                title="Download"
                              >
                                <i class="bi bi-arrow-down-square"></i>
                              </button>
                            )}

                          </div>
                        </div>

                      </div>
                      {/* <div className="card-body"> */}
                      <div className={`card-body ${isFirstSubmit || isFirstReject ? 'blur-background' : ''}`.trim()}>


                        <div className="card-body pdg">
                          <div className="table-responsive">

                            <div className="form theme-form">
                              <div className="card-body custom-input">


                                <div className="row">
                                  <div className="col-md-3">
                                    <label>Admission Year <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="admyear"
                                      name="admyear"
                                      className="form"
                                      styles={customStyles}
                                      options={admissionYears}
                                      onChange={handleAdmissionYearChange}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Semester <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="semester_id"
                                      name="semester_id"
                                      className="form"
                                      styles={customStyles}
                                      options={[
                                        { value: 1, label: '1' },
                                        { value: 2, label: '2' },
                                        { value: 3, label: '3' },
                                        { value: 4, label: '4' }
                                      ]}
                                      onChange={handleSemesterChange}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Discipline <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}
                                      onChange={handleDisciplineChange}
                                      options={flag
                                        ? [{ value: '0', label: 'No data found' }]
                                        : disciplinedata
                                          .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                          .map(disciplines => ({
                                            did: disciplines.discipline_id,
                                            value: disciplines.course_discipline_name,
                                            label: disciplines.course_discipline_name,
                                            type: disciplines.college_course_type
                                          }))
                                      }
                                    
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Candidates</label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="candidate"
                                      name="candidate"
                                      className="form"
                                      styles={customStyles}
                                      options={[
                                        { value: 0, label: 'All' },
                                        { value: 1, label: 'Own college students' },
                                        { value: 2, label: 'Out-of-college students' }
                                      ]}
                                      onChange={(option) => setCandidateType(option.value)}
                                      defaultValue={{ value: 1, label: 'Own college students' }}
                                    />
                                  </div>
                                </div>

                                <div className="txt-aln-jst m-10">
                                  {/* <p>
                                  <span className="text-danger">Note: This page is intended to track the status of students, whether they have completed the course registration process or not. It is not meant for verifying the course registrations made by students. Verification should only be carried out after the student portal has closed. Please note that students can modify their course selections up until the portal's closing time.
                                  </span>
                                  </p> */}
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="m-t-10">
                                      {status && (
                                        <>
                                          <input id="select-all" type="checkbox"
                                            onChange={handleSelectAll}
                                            checked={isSelectAllChecked} />
                                          <label for="select-all">&nbsp;Select All</label>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-6 txt-aln-end">
                                    {status && (
                                      <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Forwarded to University</button>
                                    )}
                                  </div>
                                </div>


                                <div class="table-container">
                                  <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        <th scope="col" style={{ width: 50 }}>
                                          {status && (
                                            <input id="select-all" type="checkbox"
                                              onChange={handleSelectAll}
                                              checked={isSelectAllChecked} />
                                          )}
                                        </th>
                                        {/* <th scope="col" width="10%">Sl No</th> */}
                                        <th scope="col" width="18%">APAAR</th>
                                        <th scope="col" width="20%">Name</th>
                                        <th scope="col" width="60%">Courses</th>
                                        <th scope="col" width="25%">Approve/ Reject</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredStudents.length > 0 ? (
                                        filteredStudents.map(([apaarId, studentDetails], index) => (
                                          <tr key={apaarId}>
                                            <td scope="row">
                                              {studentDetails.studentstatus !== 'Not Verified' && status ? (
                                                <input type="checkbox" value={apaarId}
                                                  checked={selectedStudents.includes(apaarId)}
                                                  onChange={() => handleCheckboxChange(apaarId)} />
                                              ) : (
                                                studentDetails.principal_status !== 'Not Approved' ? (
                                                  <span class="badge badge-success text-white rounded-pill"><i class="fa fa-check" aria-hidden="true"></i></span>

                                                ) : (
                                                  studentDetails.courses.some(course => course.studentstatus === 'Principal Rejected') ? (
                                                    <span class="badge badge-danger text-white rounded-pill">x</span>
                                                  ) : null
                                                )
                                              )}
                                            </td>
                                            {/* <td data-label="Sl No">{index + 1}</td> */}
                                            <td data-label="APAAR Id">{apaarId}</td>
                                            <td data-label="Name">{studentDetails.studentname}</td>
                                            <td data-label="Courses"><div className="treeview">
                                              <ul>
                                                {studentDetails.courses.map((course, courseIndex) => (
                                                  <li key={courseIndex}>
                                                    {course.paper_identifier}: {course.course_name}

                                                    {course.student_college_type === 'external' ? (
                                                      <span className="badge badge-danger text-white rounded-pill">External</span>
                                                    ) : (
                                                      ''
                                                    )}

                                                    {course.studentstatus === 'Entered' ? (
                                                      <span className="badge badge-warning text-white rounded-pill">{course.studentstatus}</span>
                                                    ) : course.studentstatus === 'DEO Rejected' ? (
                                                      <span className="badge badge-danger text-white rounded-pill">{course.studentstatus}</span>
                                                    ) : course.studentstatus === 'Principal Approved' ? (
                                                      <span className="badge badge-success text-white rounded-pill">{course.studentstatus}</span>
                                                    ) : course.studentstatus === 'DEO Verified' ? (
                                                      <span className="badge badge-warning text-white rounded-pill">{course.studentstatus}</span>
                                                    ) : (
                                                      <span className="badge badge-danger text-white rounded-pill">{course.studentstatus}</span>
                                                    )}

                                                  </li>
                                                ))}
                                              </ul>
                                            </div>

                                            </td>
                                            <td data-label="Approve/ Reject">
                                              {studentDetails.studentstatus !== 'Not Verified' && status ? (
                                                <>
                                                  <textarea class="form-control" placeholder='Remarks' onChange={(e) => setRemarks(e.target.value)}></textarea><br />
                                                  <button class="btn btn-pill btn-outline-danger btn-sm" type="button" onClick={() => handlefirstReject(apaarId)}>Reject</button>
                                                </>) : (
                                                studentDetails.principal_status === 'Not Approved' ? (
                                                  <div>
                                                    Approval Pending
                                                  </div>
                                                ) : (
                                                  <div>
                                                    Forwarded to University
                                                  </div>
                                                )

                                              )}

                                            </td>

                                          </tr>

                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="6" style={{ textAlign: 'center' }}>No data available</td>
                                        </tr>
                                      )}


                                    </tbody>
                                  </table>


                                </div>

                              </div>
                              <div className="col-md-12 txt-aln ">
                                {/* <textarea style={{ width: 400 }} placeholder='Remarks'></textarea><br /> */}

                                {status && (
                                  <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Forward to University</button>
                                )}
                              </div>


                            </div>



                          </div>
                        </div>
                      </div>



                      <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content mod-scn">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to proceed Forward to University?</h4>
                                <p className="txt-aln"></p>
                                <div className="d-flex justify-content-center mt-3">

                                  <div>

                                    <button className="btn btn-danger mx-2" onClick={handleApproveAll}>Save</button>


                                    <button
                                      className="btn"
                                      style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                      data-bs-dismiss="modal"
                                      onClick={handleCancel}
                                    >
                                      Cancel
                                    </button>
                                  </div>



                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`modal fade show ${isFirstReject ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content mod-scn">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to Reject?</h4>
                                <p className="txt-aln"></p>
                                <div className="d-flex justify-content-center mt-3">

                                  <div>

                                    <button className="btn btn-danger mx-2" onClick={() => handleReject(getApaarIDS)}>Reject</button>


                                    <button
                                      className="btn"
                                      style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                      data-bs-dismiss="modal"
                                      onClick={handleRejectCancel}
                                    >
                                      Cancel
                                    </button>
                                  </div>



                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
